module.exports = {"331122001":"五云街道","331122002":"新碧街道","331122003":"仙都街道","331122101":"壶镇镇","331122102":"新建镇","331122103":"舒洪镇","331122105":"大洋镇","331122106":"东渡镇","331122107":"东方镇","331122108":"大源镇","331122203":"七里乡","331122206":"前路乡","331122207":"三溪乡","331122208":"溶江乡","331122209":"双溪口乡","331122210":"胡源乡","331122211":"方溪乡","331122212":"石笕乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331122.json
// module id = 1131
// module chunks = 0